module.exports = __webpack_public_path__ + "img/3-2.24d82e4d.svg";